import { fadeInOut } from '../../services/animations';
import { Component, AfterViewInit, ViewContainerRef, ViewChildren, ComponentFactory, Type, NgModule, QueryList, ViewEncapsulation, ElementRef, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import $ from "jquery";
import { Programme } from '../../models/programme.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgrammesService } from '../../services/programmes.service';
import { TableauxService } from '../../services/tableaux.service';

@Component({
  selector: 'app-tableaux',
  templateUrl: './tableaux.page.component.html',
  styleUrls: ['./tableaux.page.component.scss'],
  animations: [fadeInOut],
})

export class TableauxPageComponent implements AfterViewInit, OnInit {
  @ViewChildren('programmeRow', { read: ViewContainerRef }) children: QueryList<ViewContainerRef>;
  form: FormGroup;
  programmes: Array<Programme>;
  programmesAvecTableau: Array<Programme>;
  myEventSubscription: any;
  sortKey = 'nom';
  sortReverse = false;
  searchTerm: string;
  public loading: boolean = false;
  routeToRead: boolean = true;
  private sub: any;

  constructor(
    fb: FormBuilder,
    private progservice: ProgrammesService,
    private tabservice: TableauxService,
    private route: ActivatedRoute,
    private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.searchTerm = '';
    this.loadProgrammesActifs();
  }

  ngAfterViewInit(): void {
    window.onscroll = () => { scrollFunction() };

    function scrollFunction() {
      var backToTop = $('.back-to-top');
      if (backToTop != null) {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
          $('.back-to-top').fadeIn(200);
        } else {
          $('.back-to-top').fadeOut();
        }
      }
    }
  }

  changeSortKey(newSortKey: string): void {
    if (this.sortKey == newSortKey) {
      this.sortReverse = !this.sortReverse;
    }
    else {
      this.sortKey = newSortKey;
      this.sortReverse = false;
    }
  }

  loadProgrammesActifs() {
    this.progservice.getProgrammesActifs().subscribe(res => {
      this.programmes = res;
      this.loading = false;
      this.sub = this.route.params.pipe(
        takeWhile(() => this.routeToRead))
        .subscribe(params => {
          var ProgrammeId = params['programmeId'];
          if (ProgrammeId) {
            setTimeout(() => {
              const el: any = this.children.find(x => x.element.nativeElement.id === 'collapseProgramme' + ProgrammeId);
              const element: any = ($(el.element.nativeElement) as any);
              const programme = this.programmes.find(x => x.programmeId == ProgrammeId);

              element.collapse('show');
              this.loadProgrammesAvecTableaux(programme);

              $('html, body').animate({
                scrollTop: element.position().top - 44
              }, 1000);
            }, 100);
          }
          this.routeToRead = false;
        });
    });
  }

  loadProgrammesAvecTableaux(programme: Programme) {
    this.loading = true;
    this.progservice.getAllProgrammesAvecTableaux(programme.programmeId).subscribe(res => {
      this.programmesAvecTableau = res;
      this.loading = false;
    });
  }

  backToTop() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  clearSearchTerm() {
    this.collapseListeProgrammes();
  }

  collapseListeProgrammes() {
    this.loading = true;
    this.searchTerm = '';
    this.programmes = new Array<Programme>();
    this.programmesAvecTableau = new Array<Programme>();
    this.loadProgrammesActifs();
  }

}
